import React, { useContext, VFC } from 'react';

import { get } from 'lodash';
import { useId } from 'react-id-generator';

import ArticleBlock from '/components/ArticleBlock';
import { ContentColumn } from '/components/BlockColumns';
import { BlockProps, ColumnContainerJson } from '/types';
import { PresentModeContext } from '/utils/contexts';

const BlockContent: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  presentOption,
  ...props
}) => {
  const presentMode = useContext(PresentModeContext);
  const columnData = get(props.blockContent, 'columns.list', []);
  const numbered = props.blockType === 'block-content-3-cols-numbered';
  const threeCols = props.blockType.startsWith('block-content-3-cols');
  const animationComplete = animationStep >= columnData.length;
  setAnimationComplete(animationComplete);

  const ids = useId(columnData.length);

  return (
    <ArticleBlock
      {...props}
      hideFooter={animationEnabled && !animationComplete}
      titleCentered={columnData.length > 1}
      presentCenterAlignDisabled={columnData.length > 1}
      columns={columnData.map(
        (column: ColumnContainerJson, columnNumber: number) =>
          !column.hidden &&
          column.name === 'content' && (
            <ContentColumn
              {...column}
              key={ids[columnNumber]}
              columnNumber={columnNumber + 1}
              numbered={numbered}
              textCentered={threeCols && !!presentMode}
              presentOption={presentOption}
              hide={animationEnabled && animationStep <= columnNumber}
            />
          ),
      )}
    />
  );
};

BlockContent.displayName = 'BlockContent';
export default BlockContent;
